<template>
  <div class="container header">
    <div class="logo">
      <router-link to="/">
        <img :src="site.phoneWebsiteLogo" height="40" v-if="site" />
      </router-link>
    </div>
    <div class="right">
      <!-- <changeColor /> -->
      <el-dropdown v-if="userInfo">
        <span class="el-dropdown-link">
          <div class="name">{{ userInfo.username }}<i class="el-icon-arrow-down el-icon--right"></i></div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="$router.push('/user')">{{ ts('Personal Center')['Personal Center'] }}</el-dropdown-item>
          <el-dropdown-item @click.native="logout">{{ ts('LOG-OUT')['LOG-OUT'] }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <template v-else>
        <div class="btn-login">
          <el-button type="text" @click="$router.push('/login')">{{ ts('Login')['Login'] }}</el-button>
        </div>
        <div class="btn btn-theme" @click="$router.push('/register')">{{ ts('Join')['Join'] }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import changeColor from '@/components/theme.vue'
import { USER_INFO } from '@/store/mutation-types'
import { LanguagePackage } from '@/mixins/LanguagePackage'

export default {
  name: '',
  mixins: [LanguagePackage],
  data() {
    return {
      userInfo: this.$ls.get(USER_INFO),
    }
  },
  components: {
    changeColor,
  },
  computed: {
    ...mapState(['site']),
  },
  methods: {
    logout() {
      this.$store.dispatch('Logout')
    },
  },
}
</script>
